module.exports = __webpack_public_path__ + "img/LMS_LOGO.8157ce49.png";